import { render, staticRenderFns } from "./OxygenControlName.vue?vue&type=template&id=1e8e300e&"
import script from "./OxygenControlName.vue?vue&type=script&lang=ts&"
export * from "./OxygenControlName.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenControlName.vue?vue&type=style&index=0&id=1e8e300e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports